<template>
  <div class="qrCodeBox">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="title">
          {{ businessContent.channel == "dxlc" ? "柳州" : "南通" }}公交乘车码
        </div>

        <div class="qrErrorBox" v-if="isExpire">
          <img
            class="qrCodeErrorImg"
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/qrCodeError.png"
            alt=""
          />
          <div class="qrCodeErrorText">乘车码已失效</div>
        </div>

        <div
          class="qrContent"
          v-if="isOpen === true && isExpire == false && qrCodeData"
        >
          <!-- 二维码图片 -->
          <img
            class="qrCodeImg"
            v-if="qrCodeData != '' && isOpen"
            :src="qrCodeData"
            alt=""
          />
        </div>

        <!-- 二维码异常 -->
        <div class="qrErrorBox" v-if="isOpen === false && isExpire == false">
          <img
            class="qrCodeErrorImg"
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/qrCodeError.png"
            alt=""
          />
          <div class="qrCodeErrorText">{{ errorMsg }}</div>
        </div>
        <div
          class="openQrCodeBtn"
          v-if="isOpen === false && isExpire == false"
          @click="jumpToNativeQrCodePage"
        >
          {{ buttonText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      qrCodeData: "",
      isExpire: false,
      isOpen: true,
      timer: null,
      errorMsg: "",
      buttonText: "",
    };
  },
  props: ["businessContent"],
  computed: {
    cityName: function () {
      if (this.qrCodeData) {
        return this.qrCodeData.cityName;
      } else {
        return null;
      }
    },
    qrCodeImg: function () {
      if (this.qrCodeData) {
        return this.qrCodeData.qrCodeImg;
      } else {
        return null;
      }
    },
  },
  mounted: function () {
    console.log(this.businessContent);
    // 获取二维码成功
    if (this.businessContent.bizCode == "SUCCESS") {
      this.qrCodeData = JSON.parse(this.businessContent.bizData).imageData;
      console.log(this.qrCodeData);
    }
    // 暂未开通
    else if (this.businessContent.bizCode == "NONE_PAY_CARD") {
      this.isOpen = false;
      this.errorMsg = "暂未开通乘车码";
      this.buttonText = "去开通";
    } else {
      this.isOpen = false;
      this.errorMsg = "乘车码异常";
      this.buttonText = "查看详情";
    }
    this.checkIsExpire(this.businessContent);
  },
  methods: {
    // 跳转到native/小程序 生码页面
    jumpToNativeQrCodePage: function () {
      if (window.__wxjs_environment) {
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            wx.miniProgram.postMessage({
              data: {
                type: "go_ride",
              },
            });
            wx.miniProgram.navigateBack({
              delta: 1,
            });
          }
        });
      } else {
        window.location.href = "liangla://trans";
      }
    },
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击去开通按钮
  },
};
</script>

<style lang="scss" scoped>
@import "./qrCodeBox.scss";
</style>
